import React from "react";
import {SelectField} from "./FilterComponentStyles";

const IntegrationTypeFilter = ({
    value,
    onChange,
    showLabel = true,
    showAllOption = true,
    mode = undefined,
    selectMarginBottom = "20px",
    allowClear = false
}) => {
    return (
        <React.Fragment>
            {showLabel && <h5>{"Entegrasyon Tipi"}</h5>}
            <SelectField
                value={value}
                onChange={onChange}
                mb={selectMarginBottom}
                allowClear={allowClear}
                showAllOption={showAllOption}
                mode={mode}
            >
                <SelectField.Option value="all">Tümü</SelectField.Option>
                <SelectField.Option value="pool">Havuz</SelectField.Option>
                <SelectField.Option value="dedicated">Dedike</SelectField.Option>
                <SelectField.Option value="dedicatedIntegration">
                    Dedike Entegrasyon
                </SelectField.Option>
            </SelectField>
        </React.Fragment>
    );
};

export default IntegrationTypeFilter;
